module.exports = __webpack_public_path__ + "static/media/evaluation-background.e7cc85a3.jpg";